import Modal from './Modal';
import { drawer } from './DrawerDialog.css';
import { useMediaQuery } from 'react-responsive';
import { arrowsDropdown, dropdown, select } from '../forms/Select.css';
import { useDismissible } from '@instamenu/react-hooks';
import { createPortal } from 'react-dom';

type DrawerDialogProps = {
  children: React.ReactNode;
  disabled?: boolean;
  full?: boolean;
  visible?: boolean;
  label: React.ReactNode | string;
  setVisible: (visible: boolean) => void;
  overrideStyle?: object;
  arrows?: boolean;
  triggerDataId?: string;
};

export default function DrawerDialog({
  children,
  disabled,
  full = false,
  label,
  visible = false,
  setVisible,
  overrideStyle,
  arrows = false,
  triggerDataId,
}: DrawerDialogProps) {
  const isDesktop = useMediaQuery({ query: `(min-width: 768px)` });
  const { ref } = useDismissible<HTMLDivElement>(() => {
    if (isDesktop) setVisible(false);
  });

  const portalContent = isDesktop && visible && (
    <div
      className={arrows ? arrowsDropdown : dropdown}
      style={overrideStyle && isDesktop ? overrideStyle : {}}
    >
      {children}
    </div>
  );

  return (
    <>
      <div style={{ position: 'relative' }} ref={ref}>
        {arrows ? (
          label
        ) : (
          <div
            className={select}
            data-id={triggerDataId}
            style={{ borderRadius: '0.3rem', pointerEvents: disabled ? 'none' : undefined }}
            onClick={() => {
              if (!disabled) setVisible(!visible);
            }}
          >
            <span style={{ textOverflow: 'ellipsis', overflow: 'hidden', whiteSpace: 'nowrap' }}>
              {label}
            </span>
          </div>
        )}
        {!isDesktop
          ? createPortal(
              <Modal full={full} visible={visible} onRequestClose={() => setVisible(false)}>
                <div className={drawer}>{children}</div>
              </Modal>,
              document.body,
            )
          : portalContent}
      </div>
    </>
  );
}
